import { createDraftGuaranteesV2 } from './http'
import { fromGuaranteeResponses, toRequests } from '../models/mapper'
import { GuaranteeUpdate } from '../models/request'
import { Guarantee } from '../models/types'

// eslint-disable-next-line import/prefer-default-export
export async function createDraftGuarantees(updates: GuaranteeUpdate[]): Promise<Guarantee[]> {
  const responses = await createDraftGuaranteesV2(toRequests(updates))

  return fromGuaranteeResponses(responses)
}
